// Shadow Network — Permissions helper.
// Phase 2 — additive. Read by the ProGate component to decide whether to show
// the real content or a paywall overlay. NO existing code path is changed.
//
// PERMISOS map: which Shadow feature requires which tier.
//   - "free": signed-in operators (FREE & PRO) can use it
//   - "pro":  only PRO operators can use it
//
// Detection: we treat `user.is_pro === true` as authoritative. Some legacy
// docs may carry `plan: 'PRO'` or `subscription_status: 'active'` — accept
// those too so the helper is forgiving.

export const PERMISOS = {
  // FREE-tier (open to everyone authenticated)
  comentar: "free",
  publicar: "free", // text post, max 500 chars + 1 image — limites se aplican en el modal
  ranking: "free",

  // PRO-only
  mensajes: "pro",
  seguir: "pro",
  videos: "pro",
  chat: "pro",
  guardados: "pro",
};

// FREE-tier publishing limits. PRO users skip all of these.
export const FREE_POST_LIMITS = {
  maxChars: 500,
  maxImages: 1,
  allowVideo: false,
};

export const PRO_POST_LIMITS = {
  maxChars: 5000,
  maxImages: 5,
  allowVideo: true,
};

export function postLimitsFor(user) {
  return isPro(user) ? PRO_POST_LIMITS : FREE_POST_LIMITS;
}

export function isPro(user) {
  if (!user) return false;
  if (user.is_pro === true) return true;
  const plan = (user.plan || "").toString().toLowerCase();
  if (plan === "pro" || plan === "lifetime") return true;
  const sub = (user.subscription_status || "").toString().toLowerCase();
  if (sub === "active" || sub === "trialing") return true;
  return false;
}

export function canUse(feature, user) {
  const need = PERMISOS[feature];
  if (need === "free") return !!user;
  if (need === "pro") return isPro(user);
  // Unknown feature → safest is to allow only PRO.
  return isPro(user);
}
